<template>
	<v-sheet class="my-4" elevation="0">
		<h6 class="text-h6 font-weight-bold">基本情報</h6>
		<v-row no-gutters>
			<v-col class="px-2 mt-2" cols="12" :lg="!isShow ? 12 : 4" :sm="!isShow ? 12 : 6">
				<v-sheet elevation="0">
					<v-sheet elevation="0" width="100%" max-width="600px">
						<table width="100%" :class="`show-dialog-table ${isShow || 'show-dialog-table--form'}`">
							<tbody>
								<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'工事名'">
									<template v-slot:value>
										<template v-if="isShow"> XXXXX </template>
										<v-text-field
											v-else
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
									</template>
								</ShowDetailRecord>
								<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'品名'">
									<template v-slot:value>
										<template v-if="isShow"> XXXXX </template>
										<v-text-field
											v-else
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
									</template>
								</ShowDetailRecord>
								<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'寸法'">
									<template v-slot:value>
										<template v-if="isShow"> XXXXX </template>
										<v-text-field
											v-else
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
									</template>
								</ShowDetailRecord>
								<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'数量'">
									<template v-slot:value>
										<template v-if="isShow"> XXXXX </template>
										<v-text-field
											v-else
											v-model="todo"
											background-color="white"
											outlined
											dense
											type="number"
											hide-spin-buttons
											hide-details
										/>
									</template>
								</ShowDetailRecord>
							</tbody>
						</table>
					</v-sheet>
				</v-sheet>
			</v-col>
			<template v-if="isShow">
				<v-col class="px-2 mt-2" cols="12" lg="4" sm="3">
					<v-sheet elevation="0">
						<table width="100%" :class="`show-dialog-table`">
							<tbody>
								<ShowDetailRecord
									:thStyle="{ fontSize: '0.9rem' }"
									:columnName="'予算状態'"
									:value="'XXX'"
								/>
								<ShowDetailRecord
									:thStyle="{ fontSize: '0.9rem' }"
									:columnName="'予算作成日'"
									:value="'XXXX/XX/XX'"
								/>
								<ShowDetailRecord
									:thStyle="{ fontSize: '0.9rem' }"
									:columnName="'予算作成者'"
									:value="'XXX XXX'"
								/>
								<ShowDetailRecord
									:thStyle="{ fontSize: '0.9rem' }"
									:columnName="'予算承認者'"
									:value="'XXX XXX'"
								/>
								<ShowDetailRecord
									:thStyle="{ fontSize: '0.9rem' }"
									:columnName="'予算承認日'"
									:value="'XXXX/XX/XX'"
								/>
							</tbody>
						</table>
					</v-sheet>
				</v-col>
				<v-col class="px-2 mt-2" cols="12" lg="4" sm="3">
					<v-sheet elevation="0">
						<table width="100%" :class="`show-dialog-table`">
							<tbody>
								<ShowDetailRecord
									:thStyle="{ fontSize: '0.9rem' }"
									:columnName="'実績状態'"
									:value="'XXX'"
								/>
								<ShowDetailRecord
									:thStyle="{ fontSize: '0.9rem' }"
									:columnName="'実績作成日'"
									:value="'XXXX/XX/XX'"
								/>
								<ShowDetailRecord
									:thStyle="{ fontSize: '0.9rem' }"
									:columnName="'実績作成者'"
									:value="'XXX XXX'"
								/>
								<ShowDetailRecord
									:thStyle="{ fontSize: '0.9rem' }"
									:columnName="'実績承認者'"
									:value="'XXX XXX'"
								/>
								<ShowDetailRecord
									:thStyle="{ fontSize: '0.9rem' }"
									:columnName="'実績承認日'"
									:value="'XXXX/XX/XX'"
								/>
							</tbody>
						</table>
					</v-sheet>
				</v-col>
			</template>
		</v-row>
		<v-row no-gutters class="flex-nowrap">
			<v-sheet class="mt-4 mr-4" elevation="0">
				<v-sheet elevation="0" width="">
					<table width="100%" class="mt-2 show-dialog-table">
						<tbody>
							<tr>
								<td class="title-in-cell">
									<h6 class="text-h6 font-weight-bold">面積計算</h6>
								</td>
								<template v-if="isActual">
									<th colspan="5">予算</th>
									<th v-if="isActual" colspan="5">実績</th>
								</template>
							</tr>
							<tr>
								<th :style="width(200)" rowspan="2">図番</th>
								<th :style="width(100)" rowspan="2">施工数量</th>
								<th :style="width(200)" colspan="2">施工面積</th>
								<th :style="width(200)" colspan="2">必要ゴムシート面積</th>
								<template v-if="isActual">
									<th :style="width(100)" rowspan="2">施工数量</th>
									<th :style="width(200)" colspan="2">施工面積</th>
									<th :style="width(200)" colspan="2">必要ゴムシート面積</th>
								</template>
							</tr>
							<tr>
								<th :style="width(100)">単品</th>
								<th :style="width(100)">合計</th>
								<th :style="width(100)">単品</th>
								<th :style="width(100)">合計</th>
								<template v-if="isActual">
									<th :style="width(100)">単品</th>
									<th :style="width(100)">合計</th>
									<th :style="width(100)">単品</th>
									<th :style="width(100)">合計</th>
								</template>
							</tr>
						</tbody>
						<tbody>
							<tr v-for="i of 5" :key="i">
								<td>
									<v-text-field
										v-if="!isActual && !isShow"
										v-model="todo"
										outlined
										dense
										hide-details
									/>
									<template v-else>XXX</template>
								</td>
								<td>
									<v-text-field
										v-if="!isActual && !isShow"
										v-model="todo"
										outlined
										dense
										hide-details
									/>
									<template v-else>XXX</template>
								</td>
								<td>
									<v-text-field
										v-if="!isActual && !isShow"
										v-model="todo"
										outlined
										dense
										hide-details
									/>
									<template v-else>XXX</template>
								</td>
								<td>XXX</td>
								<td>
									<v-text-field
										v-if="!isActual && !isShow"
										v-model="todo"
										outlined
										dense
										hide-details
									/>
									<template v-else>XXX</template>
								</td>
								<td>XXX</td>
								<template v-if="isActual">
									<td>
										<v-text-field v-if="!isShow" v-model="todo" outlined dense hide-details />
										<template v-else>XXX</template>
									</td>
									<td>
										<v-text-field v-if="!isShow" v-model="todo" outlined dense hide-details />
										<template v-else>XXX</template>
									</td>
									<td>XXX</td>
									<td>
										<v-text-field v-if="!isShow" v-model="todo" outlined dense hide-details />
										<template v-else>XXX</template>
									</td>
									<td>XXX</td>
								</template>
							</tr>

							<tr>
								<th colspan="3">合計</th>
								<td>XXX</td>
								<td class="no-border-bottom" />
								<td>XXX</td>
								<template v-if="isActual">
									<td colspan="2" class="no-border-bottom" />
									<td>XXX</td>
									<td class="no-border-bottom" />
									<td>XXX</td>
								</template>
							</tr>
						</tbody>
					</table>
					<v-btn v-if="!isShow" class="mt-2" color="secondary">
						<v-icon class="mr-1">mdi-plus</v-icon>
						図番入力欄を追加
					</v-btn>
				</v-sheet>
			</v-sheet>
			<v-sheet class="mt-4" elevation="0">
				<h6 class="text-h6 font-weight-bold">見積条件</h6>
				<v-sheet elevation="0" width="400px" min-width="400px">
					<table
						width="100%"
						:class="`mt-2 show-dialog-table ${isShow || 'show-dialog-table--form'}`"
					>
						<tbody>
							<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'施工場所'">
								<template v-slot:value>
									<v-text-field
										v-if="!isShow"
										v-model="todo"
										background-color="white"
										outlined
										dense
										hide-details
									/>
									<template v-else>XXX</template>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'顧客無償支給'">
								<template v-slot:value>
									<v-text-field
										v-if="!isShow"
										v-model="todo"
										background-color="white"
										outlined
										dense
										hide-details
									/>
									<template v-else>XXX</template>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord
								:thStyle="{ fontSize: '0.9rem' }"
								:columnName="'小型ボイラー設置場所'"
							>
								<template v-slot:value>
									<v-text-field
										v-if="!isShow"
										v-model="todo"
										background-color="white"
										outlined
										dense
										hide-details
									/>
									<template v-else>XXX</template>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'下流作業'">
								<template v-slot:value>
									<v-text-field
										v-if="!isShow"
										v-model="todo"
										background-color="white"
										outlined
										dense
										hide-details
									/>
									<template v-else>XXX</template>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'ゴム材質・厚み'">
								<template v-slot:value>
									<v-text-field
										v-if="!isShow"
										v-model="todo"
										background-color="white"
										outlined
										dense
										hide-details
									/>
									<template v-else>XXX</template>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'現地作業時の宿泊'">
								<template v-slot:value>
									<v-text-field
										v-if="!isShow"
										v-model="todo"
										background-color="white"
										outlined
										dense
										hide-details
									/>
									<template v-else>XXX</template>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'施工条件'">
								<template v-slot:value>
									<v-text-field
										v-if="!isShow"
										v-model="todo"
										background-color="white"
										outlined
										dense
										hide-details
									/>
									<template v-else>XXX</template>
								</template>
							</ShowDetailRecord>
						</tbody>
					</table>
				</v-sheet>
			</v-sheet>
		</v-row>

		<v-row no-gutters class="mt-4">
			<v-sheet elevation="0" width="100%" max-width="400px">
				<table
					width="100%"
					:class="`mt-2 show-dialog-table ${isShow || 'show-dialog-table--form'}`"
				>
					<tbody>
						<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'工事種類'">
							<template v-slot:value>
								<template v-if="isShow"> XXXXX </template>
								<v-text-field
									v-else
									v-model="todo"
									background-color="white"
									outlined
									dense
									hide-details
								/>
							</template>
						</ShowDetailRecord>
					</tbody>
				</table>
			</v-sheet>
			<v-sheet elevation="0" width="100%" max-width="400px">
				<table
					width="100%"
					:class="`mt-2 show-dialog-table ${isShow || 'show-dialog-table--form'}`"
				>
					<tbody>
						<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'工事体制'">
							<template v-slot:value>
								<template v-if="isShow"> XXXXX </template>
								<v-text-field
									v-else
									v-model="todo"
									background-color="white"
									outlined
									dense
									hide-details
								/>
							</template>
						</ShowDetailRecord>
					</tbody>
				</table>
			</v-sheet>
			<v-sheet elevation="0" width="100%" max-width="400px">
				<table
					width="100%"
					:class="`mt-2 show-dialog-table ${isShow || 'show-dialog-table--form'}`"
				>
					<tbody>
						<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'工事部分名'">
							<template v-slot:value>
								<template v-if="isShow"> XXXXX </template>
								<v-text-field
									v-else
									v-model="todo"
									background-color="white"
									outlined
									dense
									hide-details
								/>
							</template>
						</ShowDetailRecord>
					</tbody>
				</table>
			</v-sheet>
		</v-row>

		<v-sheet elevation="0" class="mt-4 overflow-y-auto" width="100%" max-width="100%">
			<table class="days-table" width="100%">
				<thead>
					<tr>
						<th class="fixed" rowspan="2" :style="{ ...width(100), left: '0px' }">工事項目</th>
						<th class="fixed" rowspan="2" :style="{ ...width(80), left: '99px' }">見込み</th>
						<th v-for="day of days" :key="day" :style="width(50)" :class="classByWeekday(day)">
							{{ weekday(day) }}
						</th>
					</tr>
					<tr>
						<th v-for="day of days" :key="day" :style="width(50)" :class="classByWeekday(day)">
							{{ day }}
						</th>
					</tr>
				</thead>

				<tbody>
					<!-- TODO templateをv-for -->
					<template v-for="i of 5">
						<tr :key="i">
							<th rowspan="2" class="fixed" :style="{ ...width(100), left: '0px' }">(項目名)</th>
							<th class="fixed" :style="{ ...width(80), left: '99px' }">社員</th>
							<td
								v-for="day of days"
								:key="day"
								:class="`${classByWeekday(day)} ${isShow || isActual ? '' : 'pa-0'}`"
							>
								<v-text-field
									v-if="!isShow && !isActual"
									class="no-line"
									:rules="[rules.integer]"
									dense
									outlined
									hide-details
								/>
								<template v-else>XX</template>
							</td>
						</tr>
						<tr :key="i">
							<th class="fixed" :style="{ left: '99px' }">外注</th>
							<td
								v-for="day of days"
								:key="day"
								:class="`${classByWeekday(day)} ${isShow || isActual ? '' : 'pa-0'}`"
							>
								<v-text-field
									v-if="!isShow && !isActual"
									class="no-line"
									:rules="[rules.integer]"
									dense
									outlined
									hide-details
								/>
								<template v-else>XX</template>
							</td>
						</tr>
					</template>

					<tr>
						<th rowspan="2" class="fixed" :style="{ left: '0px' }">合計</th>
						<th class="fixed" :style="{ left: '99px' }">社員</th>
						<td v-for="day of days" :key="day" :class="classByWeekday(day)">
							{{ totalByDays(day, "employee") }}
						</td>
					</tr>
					<tr>
						<th class="fixed" :style="{ left: '99px' }">外注</th>
						<td v-for="day of days" :key="day" :class="classByWeekday(day)">
							{{ totalByDays(day, "outsource") }}
						</td>
					</tr>

					<tr>
						<th class="fixed" :style="{ left: '0px' }" rowspan="2">総合計</th>
						<th class="fixed" :style="{ left: '99px' }">社員</th>
						<td colspan="4">
							{{ totalDays("employee", "all") }}
							工数
						</td>
					</tr>
					<tr>
						<th class="fixed" :style="{ left: '99px' }">外注</th>
						<td colspan="4">
							{{ totalDays("outsource", "all") }}
							工数
						</td>
					</tr>

					<tr>
						<th class="fixed" :style="{ left: '0px' }" rowspan="2">内 平日</th>
						<th class="fixed" :style="{ left: '99px' }">社員</th>
						<td colspan="4">
							{{ totalDays("employee", "weekday") }}
							工数
						</td>
					</tr>
					<tr>
						<th class="fixed" :style="{ left: '99px' }">外注</th>
						<td colspan="4">
							{{ totalDays("outsource", "weekday") }}
							工数
						</td>
					</tr>

					<tr>
						<th class="fixed" :style="{ left: '0px' }" rowspan="2">内 休日</th>
						<th class="fixed" :style="{ left: '99px' }">社員</th>
						<td colspan="4">
							{{ totalDays("employee", "weekend") }}
							工数
						</td>
					</tr>
					<tr>
						<th class="fixed" :style="{ left: '99px' }">外注</th>
						<td colspan="4">
							{{ totalDays("outsource", "weekend") }}
							工数
						</td>
					</tr>
				</tbody>
			</table>
		</v-sheet>
		<v-btn v-if="!isShow" class="mt-2" color="secondary">
			<v-icon class="mr-1">mdi-plus</v-icon>
			項目を追加
		</v-btn>

		<v-sheet elevation="0" class="mt-4 overflow-y-auto" width="100%" max-width="100%">
			<table class="days-table">
				<thead>
					<tr>
						<th class="fixed" :style="{ ...width(100), left: '0px' }" rowspan="2">工事外項目</th>
						<th class="fixed" :style="{ ...width(80), left: '99px' }" rowspan="2">見込み</th>
						<th v-for="day of days" :key="day" :style="width(50)" :class="classByWeekday(day)">
							{{ weekday(day) }}
						</th>
					</tr>
					<tr>
						<th v-for="day of days" :key="day" :class="classByWeekday(day)">
							{{ day }}
						</th>
					</tr>
				</thead>

				<tbody>
					<tr>
						<th class="fixed" :style="{ left: '0px' }" rowspan="2">車の数量</th>
						<th class="fixed" :style="{ left: '99px' }">社員</th>
						<td
							v-for="day of days"
							:key="day"
							:class="`${classByWeekday(day)} ${isShow ? '' : 'pa-0'}`"
						>
							<v-text-field
								v-if="!isShow"
								class="no-line"
								:rules="[rules.integer]"
								dense
								outlined
								hide-details
							/>
							<template v-else>XX</template>
						</td>
					</tr>
					<tr>
						<th class="fixed" :style="{ left: '99px' }">外注</th>
						<td
							v-for="day of days"
							:key="day"
							:class="`${classByWeekday(day)} ${isShow ? '' : 'pa-0'}`"
						>
							<v-text-field
								v-if="!isShow"
								class="no-line"
								:rules="[rules.integer]"
								dense
								outlined
								hide-details
							/>
							<template v-else>XX</template>
						</td>
					</tr>

					<tr>
						<th class="fixed" :style="{ left: '0px' }" rowspan="2">宿泊</th>
						<th class="fixed" :style="{ left: '99px' }">社員</th>
						<td
							v-for="day of days"
							:key="day"
							:class="`${classByWeekday(day)} ${isShow ? '' : 'pa-0'}`"
						>
							<v-text-field
								v-if="!isShow"
								class="no-line"
								:rules="[rules.integer]"
								dense
								outlined
								hide-details
							/>
							<template v-else>XX</template>
						</td>
					</tr>
					<tr>
						<th class="fixed" :style="{ left: '99px' }">外注</th>
						<td
							v-for="day of days"
							:key="day"
							:class="`${classByWeekday(day)} ${isShow ? '' : 'pa-0'}`"
						>
							<v-text-field
								v-if="!isShow"
								class="no-line"
								:rules="[rules.integer]"
								dense
								outlined
								hide-details
							/>
							<template v-else>XX</template>
						</td>
					</tr>

					<tr>
						<th class="fixed" :style="{ left: '0px' }" colspan="2">作業実日数</th>
						<td
							v-for="day of days"
							:key="day"
							:class="`${classByWeekday(day)} ${isShow || isActual ? '' : 'pa-0'}`"
						>
							<v-text-field
								v-if="!isShow && !isActual"
								class="no-line"
								:rules="[rules.integer]"
								dense
								outlined
								hide-details
							/>
							<template v-else>XX</template>
						</td>
					</tr>
				</tbody>
			</table>
		</v-sheet>

		<v-sheet
			elevation="0"
			class="mt-4"
			:min-width="isActual ? '600px' : '450px'"
			:max-width="isActual ? '600px' : '450px'"
		>
			<table width="100%" class="show-dialog-table show-dialog-table--form">
				<tbody>
					<tr v-if="isActual">
						<td :style="width(300)" class="title-in-cell" colspan="3" />
						<th :style="width(150)">予算</th>
						<th :style="width(150)">実績</th>
					</tr>
					<tr>
						<th :style="width(100)" rowspan="5">総合計</th>
						<th :style="width(100)" rowspan="2">車の数量</th>
						<th :style="width(100)">社員</th>
						<td :style="width(150)" class="bg-white">XX</td>
						<td :style="width(150)" v-if="isActual" class="bg-white">XX</td>
					</tr>
					<tr>
						<th>外注</th>
						<td class="bg-white">XX</td>
						<td v-if="isActual" class="bg-white">XX</td>
					</tr>
					<tr>
						<th class="border-left" rowspan="2">宿泊</th>
						<th>社員</th>
						<td class="bg-white">XX</td>
						<td v-if="isActual" class="bg-white">XX</td>
					</tr>
					<tr>
						<th class="border-left">外注</th>
						<td class="bg-white">XX</td>
						<td v-if="isActual" class="bg-white">XX</td>
					</tr>
					<tr>
						<th class="border-left" colspan="2">実作業日数</th>
						<td class="bg-white">XX</td>
						<td v-if="isActual" class="bg-white">XX</td>
					</tr>
				</tbody>
			</table>
		</v-sheet>

		<v-row :class="{ 'flex-nowrap': true, 'flex-column': isActual }" no-gutters>
			<v-sheet elevation="0" class="mt-4 mr-4" min-width="800px" max-width="800px">
				<table
					width="100%"
					:class="`mt-2 show-dialog-table ${isShow || 'show-dialog-table--form'}`"
				>
					<tbody>
						<tr>
							<td class="title-in-cell" colspan="2">
								<h6 class="text-h6 font-weight-bold">交通費</h6>
							</td>
							<template v-if="isActual">
								<th :style="width(300)">予算</th>
								<th :style="width(300)">実績</th>
							</template>
						</tr>
						<tr>
							<th rowspan="3" :style="width(100)">高速道路</th>
							<th :style="width(100)" class="border-left">区間</th>
							<td :class="{ 'bg-white': isShow || isActual }">
								<v-row no-gutters class="flex-nowrap" align="center">
									<v-text-field
										v-if="!isShow && !isActual"
										v-model="todo"
										background-color="white"
										outlined
										dense
										hide-details
									/>
									<template v-else>XX</template>
									<div class="px-2">〜</div>
									<v-text-field
										v-if="!isShow && !isActual"
										v-model="todo"
										background-color="white"
										outlined
										dense
										hide-details
									/>
									<template v-else>XX</template>
								</v-row>
							</td>
							<td v-if="isActual" :class="{ 'bg-white': isShow }">
								<v-row no-gutters class="flex-nowrap" align="center">
									<v-text-field
										v-if="!isShow"
										v-model="todo"
										background-color="white"
										outlined
										dense
										hide-details
									/>
									<template v-else>XX</template>
									<div class="px-2">〜</div>
									<v-text-field
										v-if="!isShow"
										v-model="todo"
										background-color="white"
										outlined
										dense
										hide-details
									/>
									<template v-else>XX</template>
								</v-row>
							</td>
						</tr>
						<tr>
							<th class="border-left">通行料金</th>
							<td :class="{ 'bg-white': isShow || isActual }">
								<v-text-field
									v-if="!isShow && !isActual"
									v-model="todo"
									background-color="white"
									outlined
									dense
									hide-details
								/>
								<template v-else>XX</template>
							</td>
							<td v-if="isActual" :class="{ 'bg-white': isShow }">
								<v-text-field
									v-if="!isShow"
									v-model="todo"
									background-color="white"
									outlined
									dense
									hide-details
								/>
								<template v-else>XX</template>
							</td>
						</tr>
						<tr>
							<th class="border-left">使用回数</th>
							<td :class="{ 'bg-white': isShow || isActual }">
								<v-text-field
									v-if="!isShow && !isActual"
									v-model="todo"
									background-color="white"
									outlined
									dense
									hide-details
								/>
								<template v-else>XX</template>
							</td>
							<td v-if="isActual" :class="{ 'bg-white': isShow }">
								<v-text-field
									v-if="!isShow"
									v-model="todo"
									background-color="white"
									outlined
									dense
									hide-details
								/>
								<template v-else>XX</template>
							</td>
						</tr>
						<tr>
							<th rowspan="2">ガソリン</th>
							<th class="border-left">単価 / L</th>
							<td :class="{ 'bg-white': isShow || isActual }">
								<v-text-field
									v-if="!isShow && !isActual"
									v-model="todo"
									background-color="white"
									outlined
									dense
									hide-details
								/>
								<template v-else>XX</template>
							</td>
							<td v-if="isActual" :class="{ 'bg-white': isShow }">
								<v-text-field
									v-if="!isShow"
									v-model="todo"
									background-color="white"
									outlined
									dense
									hide-details
								/>
								<template v-else>XX</template>
							</td>
						</tr>
						<tr>
							<th class="border-left">片道距離</th>
							<td :class="{ 'bg-white': isShow || isActual }">
								<v-text-field
									v-if="!isShow && !isActual"
									v-model="todo"
									background-color="white"
									outlined
									dense
									hide-details
								/>
								<template v-else>XX</template>
							</td>
							<td v-if="isActual" :class="{ 'bg-white': isShow }">
								<v-text-field
									v-if="!isShow"
									v-model="todo"
									background-color="white"
									outlined
									dense
									hide-details
								/>
								<template v-else>XX</template>
							</td>
						</tr>
						<tr>
							<th rowspan="2">車体</th>
							<th>台数</th>
							<td :class="{ 'bg-white': isShow || isActual }">
								<v-text-field
									v-if="!isShow && !isActual"
									v-model="todo"
									background-color="white"
									outlined
									dense
									hide-details
								/>
								<template v-else>XX</template>
							</td>
							<td v-if="isActual" :class="{ 'bg-white': isShow }">
								<v-text-field
									v-if="!isShow"
									v-model="todo"
									background-color="white"
									outlined
									dense
									hide-details
								/>
								<template v-else>XX</template>
							</td>
						</tr>
						<tr>
							<th class="border-left">単価 / 台</th>
							<td :class="{ 'bg-white': isShow || isActual }">
								<v-text-field
									v-if="!isShow && !isActual"
									v-model="todo"
									background-color="white"
									outlined
									dense
									hide-details
								/>
								<template v-else>XX</template>
							</td>
							<td v-if="isActual" :class="{ 'bg-white': isShow }">
								<v-text-field
									v-if="!isShow"
									v-model="todo"
									background-color="white"
									outlined
									dense
									hide-details
								/>
								<template v-else>XX</template>
							</td>
						</tr>
						<tr>
							<th colspan="2">合計</th>
							<td class="border-bottom bg-white">XX</td>
							<td v-if="isActual" class="border-bottom bg-white">XX</td>
						</tr>
					</tbody>
				</table>
			</v-sheet>

			<v-sheet elevation="0" class="mt-4" max-width="800px">
				<h6 class="text-h6 font-weight-bold">硬質加硫</h6>
				<table
					width="100%"
					:class="`mt-2 show-dialog-table ${isShow || 'show-dialog-table--form'}`"
				>
					<tbody>
						<tr>
							<th>対象ゴム</th>
							<td colspan="4" :class="{ 'bg-white': isShow }">
								<v-text-field
									v-if="!isShow"
									v-model="todo"
									background-color="white"
									outlined
									dense
									hide-details
								/>
								<template v-else>XX</template>
							</td>
						</tr>
						<tr>
							<th>加硫条件</th>
							<td colspan="4" :class="{ 'bg-white': isShow }">
								<v-text-field
									v-if="!isShow"
									v-model="todo"
									background-color="white"
									outlined
									dense
									hide-details
								/>
								<template v-else>XX</template>
							</td>
						</tr>
						<tr v-if="isActual">
							<td colspan="2" class="title-in-cell"></td>
							<th colspan="7">予算</th>
							<th colspan="7">実績</th>
						</tr>
						<tr>
							<th colspan="2">項目 / 日目</th>

							<th
								class="border-left"
								v-for="day of hardVulcanizationDays"
								:style="width(50)"
								:key="day"
							>
								{{ day }}
							</th>
							<th :style="width(50)">累計</th>
							<template v-if="isActual">
								<th
									class="border-left"
									v-for="day of hardVulcanizationDays"
									:style="width(50)"
									:key="day"
								>
									{{ day }}
								</th>
								<th :style="width(50)">累計</th>
							</template>
						</tr>
						<tr class="days-table">
							<th colspan="2">加温(ヒートアップ)</th>
							<td
								v-for="day of hardVulcanizationDays"
								:class="`border-bottom ${isShow || isActual ? '' : 'pa-0'}`"
								:style="{ ...width(50), backgroundColor: 'white' }"
								:key="day"
							>
								<v-text-field
									v-if="!isShow && !isActual"
									class="no-line"
									:rules="[rules.integer]"
									dense
									outlined
									hide-details
								/>
								<template v-else>XX</template>
							</td>
							<td class="bg-white border-bottom" :style="width(50)">XX</td>
							<template v-if="isActual">
								<td
									v-for="day of hardVulcanizationDays"
									:class="`border-bottom ${isShow ? '' : 'pa-0'}`"
									:style="{ ...width(50), backgroundColor: 'white' }"
									:key="day"
								>
									<v-text-field
										v-if="!isShow"
										class="no-line"
										:rules="[rules.integer]"
										dense
										outlined
										hide-details
									/>
									<template v-else>XX</template>
								</td>
								<td class="bg-white border-bottom" :style="width(50)">XX</td>
							</template>
						</tr>
						<tr class="days-table">
							<th colspan="2">加硫</th>
							<td
								v-for="day of hardVulcanizationDays"
								:class="`border-bottom ${isShow || isActual ? '' : 'pa-0'}`"
								:style="{ ...width(50), backgroundColor: 'white' }"
								:key="day"
							>
								<v-text-field
									v-if="!isShow && !isActual"
									class="no-line"
									:rules="[rules.integer]"
									dense
									outlined
									hide-details
								/>
								<template v-else>XX</template>
							</td>
							<td class="bg-white border-bottom" :style="width(50)">XX</td>
							<template v-if="isActual">
								<td
									v-for="day of hardVulcanizationDays"
									:class="`border-bottom ${isShow ? '' : 'pa-0'}`"
									:style="{ ...width(50), backgroundColor: 'white' }"
									:key="day"
								>
									<v-text-field
										v-if="!isShow"
										class="no-line"
										:rules="[rules.integer]"
										dense
										outlined
										hide-details
									/>
									<template v-else>XX</template>
								</td>
								<td class="bg-white border-bottom" :style="width(50)">XX</td>
							</template>
						</tr>
						<tr>
							<th colspan="2">合計加硫時間</th>
							<td
								v-for="day of hardVulcanizationDays"
								class="border-bottom"
								:style="{ ...width(50), backgroundColor: 'white' }"
								:key="day"
							>
								XXX
							</td>
							<td class="bg-white border-bottom" :style="width(50)">XX</td>
							<template v-if="isActual">
								<td
									v-for="day of hardVulcanizationDays"
									class="border-bottom"
									:style="{ ...width(50), backgroundColor: 'white' }"
									:key="day"
								>
									XXX
								</td>
								<td class="bg-white border-bottom" :style="width(50)">XX</td>
							</template>
						</tr>
						<tr>
							<td colspan="5" class="bg-white"></td>
							<th colspan="3">加硫日数</th>
							<td class="bg-white border-bottom" :style="width(50)">XX</td>
							<template v-if="isActual">
								<td colspan="3" class="bg-white"></td>
								<th colspan="3">加硫日数</th>
								<td class="bg-white border-bottom" :style="width(50)">XX</td>
							</template>
						</tr>
					</tbody>
				</table>
				<v-btn v-if="!isShow" class="mt-2" color="secondary">
					<v-icon class="mr-1">mdi-plus</v-icon>
					日数を増やす
				</v-btn>
			</v-sheet>
		</v-row>

		<v-row :class="{ 'flex-nowrap': true, 'flex-column': isActual }" no-gutters>
			<v-sheet elevation="0" class="mt-4 mr-4" max-width="800px">
				<h6 class="text-h6 font-weight-bold">軟質加硫</h6>
				<table
					width="100%"
					:class="`mt-2 show-dialog-table ${isShow || 'show-dialog-table--form'}`"
				>
					<tbody>
						<tr>
							<th>対象ゴム</th>
							<td colspan="4">
								<v-text-field
									v-if="!isShow"
									v-model="todo"
									background-color="white"
									outlined
									dense
									hide-details
								/>
								<template v-else>XX</template>
							</td>
						</tr>
						<tr>
							<th>加硫条件</th>
							<td colspan="4">
								<v-text-field
									v-if="!isShow"
									v-model="todo"
									background-color="white"
									outlined
									dense
									hide-details
								/>
								<template v-else>XX</template>
							</td>
						</tr>

						<tr v-if="isActual">
							<td colspan="2" class="title-in-cell"></td>
							<th colspan="7">予算</th>
							<th colspan="7">実績</th>
						</tr>
						<tr>
							<th colspan="2">項目 / 日目</th>

							<th
								class="border-left"
								v-for="day of softVulcanizationDays"
								:style="width(50)"
								:key="day"
							>
								{{ day }}
							</th>
							<th :style="width(50)">累計</th>
							<template v-if="isActual">
								<th
									class="border-left"
									v-for="day of softVulcanizationDays"
									:style="width(50)"
									:key="day"
								>
									{{ day }}
								</th>
								<th :style="width(50)">累計</th>
							</template>
						</tr>
						<tr class="days-table">
							<th colspan="2">加温(ヒートアップ)</th>
							<td
								v-for="day of softVulcanizationDays"
								:class="`border-bottom ${isShow || isActual ? '' : 'pa-0'}`"
								:style="{ ...width(50), backgroundColor: 'white' }"
								:key="day"
							>
								<v-text-field
									v-if="!isShow && !isActual"
									class="no-line"
									:rules="[rules.integer]"
									dense
									outlined
									hide-details
								/>
								<template v-else>XX</template>
							</td>
							<td class="bg-white border-bottom" :style="width(50)">XX</td>
							<template v-if="isActual">
								<td
									v-for="day of softVulcanizationDays"
									:class="`border-bottom ${isShow ? '' : 'pa-0'}`"
									:style="{ ...width(50), backgroundColor: 'white' }"
									:key="day"
								>
									<v-text-field
										v-if="!isShow"
										class="no-line"
										:rules="[rules.integer]"
										dense
										outlined
										hide-details
									/>
									<template v-else>XX</template>
								</td>
								<td class="bg-white border-bottom" :style="width(50)">XX</td>
							</template>
						</tr>
						<tr class="days-table">
							<th colspan="2">加硫</th>
							<td
								v-for="day of softVulcanizationDays"
								:class="`border-bottom ${isShow || isActual ? '' : 'pa-0'}`"
								:style="{ ...width(50), backgroundColor: 'white' }"
								:key="day"
							>
								<v-text-field
									v-if="!isShow && !isActual"
									class="no-line"
									:rules="[rules.integer]"
									dense
									outlined
									hide-details
								/>
								<template v-else>XX</template>
							</td>
							<td class="bg-white border-bottom" :style="width(50)">XX</td>
							<template v-if="isActual">
								<td
									v-for="day of softVulcanizationDays"
									:class="`border-bottom ${isShow ? '' : 'pa-0'}`"
									:style="{ ...width(50), backgroundColor: 'white' }"
									:key="day"
								>
									<v-text-field
										v-if="!isShow"
										class="no-line"
										:rules="[rules.integer]"
										dense
										outlined
										hide-details
									/>
									<template v-else>XX</template>
								</td>
								<td class="bg-white border-bottom" :style="width(50)">XX</td>
							</template>
						</tr>
						<tr>
							<th colspan="2">合計加硫時間</th>
							<td
								v-for="day of softVulcanizationDays"
								class="border-bottom"
								:style="{ ...width(50), backgroundColor: 'white' }"
								:key="day"
							>
								XXX
							</td>
							<td class="bg-white border-bottom" :style="width(50)">XX</td>
							<template v-if="isActual">
								<td
									v-for="day of softVulcanizationDays"
									class="border-bottom"
									:style="{ ...width(50), backgroundColor: 'white' }"
									:key="day"
								>
									XXX
								</td>
								<td class="bg-white border-bottom" :style="width(50)">XX</td>
							</template>
						</tr>
						<tr>
							<td colspan="5" class="bg-white"></td>
							<th colspan="3">加硫日数</th>
							<td class="bg-white border-bottom" :style="width(50)">XX</td>
							<template v-if="isActual">
								<td colspan="3" class="bg-white"></td>
								<th colspan="3">加硫日数</th>
								<td class="bg-white border-bottom" :style="width(50)">XX</td>
							</template>
						</tr>
					</tbody>
				</table>
				<v-btn v-if="!isShow" class="mt-2" color="secondary">
					<v-icon class="mr-1">mdi-plus</v-icon>
					日数を増やす
				</v-btn>
			</v-sheet>

			<v-sheet elevation="0" class="mt-4">
				<v-sheet elevation="0" max-width="800px">
					<h6 class="text-h6 font-weight-bold">現地加硫の人件費割り増し計算</h6>
					<table
						width="100%"
						:class="`mt-2 show-dialog-table ${isShow || 'show-dialog-table--form'}`"
					>
						<tbody>
							<tr v-if="isActual">
								<td class="title-in-cell" :style="width(200)" />
								<th colspan="3" :style="width(300)">予算</th>
								<th colspan="3" :style="width(300)">実績</th>
							</tr>
							<tr>
								<th>項目</th>
								<th>基準額</th>
								<th>単価</th>
								<th>金額</th>
								<template v-if="isActual">
									<th>基準額</th>
									<th>単価</th>
									<th>金額</th>
								</template>
							</tr>
						</tbody>
						<tbody>
							<tr>
								<th>加硫残業分</th>
								<td :class="{ 'bg-white': isShow || isActual }">
									<v-text-field
										v-if="!isShow && !isActual"
										v-model="todo"
										background-color="white"
										outlined
										dense
										hide-details
									/>
									<template v-else>XX</template>
								</td>
								<td :class="{ 'bg-white': isShow || isActual }">
									<v-text-field
										v-if="!isShow && !isActual"
										v-model="todo"
										background-color="white"
										outlined
										dense
										hide-details
									/>
									<template v-else>XX</template>
								</td>
								<td :class="{ 'bg-white': isShow || isActual }">
									<v-text-field
										v-if="!isShow && !isActual"
										v-model="todo"
										background-color="white"
										outlined
										dense
										hide-details
									/>
									<template v-else>XX</template>
								</td>
								<template v-if="isActual">
									<td :class="{ 'bg-white': isShow }">
										<v-text-field
											v-if="!isShow"
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
										<template v-else>XX</template>
									</td>
									<td :class="{ 'bg-white': isShow }">
										<v-text-field
											v-if="!isShow"
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
										<template v-else>XX</template>
									</td>
									<td :class="{ 'bg-white': isShow }">
										<v-text-field
											v-if="!isShow"
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
										<template v-else>XX</template>
									</td>
								</template>
							</tr>
							<tr>
								<th>加硫深夜プラス</th>
								<td :class="{ 'bg-white': isShow || isActual }">
									<v-text-field
										v-if="!isShow && !isActual"
										v-model="todo"
										background-color="white"
										outlined
										dense
										hide-details
									/>
									<template v-else>XX</template>
								</td>
								<td :class="{ 'bg-white': isShow || isActual }">
									<v-text-field
										v-if="!isShow && !isActual"
										v-model="todo"
										background-color="white"
										outlined
										dense
										hide-details
									/>
									<template v-else>XX</template>
								</td>
								<td :class="{ 'bg-white': isShow || isActual }">
									<v-text-field
										v-if="!isShow && !isActual"
										v-model="todo"
										background-color="white"
										outlined
										dense
										hide-details
									/>
									<template v-else>XX</template>
								</td>
								<template v-if="isActual">
									<td :class="{ 'bg-white': isShow }">
										<v-text-field
											v-if="!isShow"
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
										<template v-else>XX</template>
									</td>
									<td :class="{ 'bg-white': isShow }">
										<v-text-field
											v-if="!isShow"
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
										<template v-else>XX</template>
									</td>
									<td :class="{ 'bg-white': isShow }">
										<v-text-field
											v-if="!isShow"
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
										<template v-else>XX</template>
									</td>
								</template>
							</tr>
							<tr>
								<th colspan="3">合計</th>
								<td class="bg-white border-bottom">XXX</td>
								<template v-if="isActual">
									<td colspan="2" class="border-bottom bg-white">XXX</td>
									<td class="bg-white border-bottom">XXX</td>
								</template>
							</tr>
						</tbody>
					</table>
					<p class="pl-1">
						2名作業で17時から22時と、5時から8時(計8時間)
						<br />
						2名作業で22時から翌朝5時(計7時間)
					</p>
				</v-sheet>
				<v-sheet elevation="0" max-width="600px">
					<table width="100%" class="mt-4 show-dialog-table show-dialog-table--form">
						<tbody>
							<tr>
								<td class="title-in-cell">
									<h6 class="text-h6 font-weight-bold">硬質加硫</h6>
								</td>
								<template v-if="isActual">
									<th :style="width(200)">予算</th>
									<th :style="width(200)">実績</th>
								</template>
							</tr>
							<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'加硫日数'">
								<template v-slot:td>
									<td :class="{ 'bg-white': isShow || isActual }">
										<v-text-field
											v-if="!isShow && !isActual"
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
										<template v-else>XX</template>
									</td>
									<td v-if="isActual" :class="{ 'bg-white': isShow }">
										<v-text-field
											v-if="!isShow"
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
										<template v-else>XX</template>
									</td>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord
								:thStyle="{ fontSize: '0.9rem' }"
								:columnName="'通常勤務のマイナス'"
							>
								<template v-slot:td>
									<td :class="{ 'bg-white': isShow || isActual }">
										<v-text-field
											v-if="!isShow && !isActual"
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
										<template v-else>XX</template>
									</td>
									<td v-if="isActual" :class="{ 'bg-white': isShow }">
										<v-text-field
											v-if="!isShow"
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
										<template v-else>XX</template>
									</td>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'小計'">
								<template v-slot:td>
									<td :class="{ 'bg-white': isShow || isActual }">
										<v-text-field
											v-if="!isShow && !isActual"
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
										<template v-else>XX</template>
									</td>
									<td v-if="isActual" :class="{ 'bg-white': isShow }">
										<v-text-field
											v-if="!isShow"
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
										<template v-else>XX</template>
									</td>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'加硫回数'">
								<template v-slot:td>
									<td :class="{ 'bg-white': isShow || isActual }">
										<v-text-field
											v-if="!isShow && !isActual"
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
										<template v-else>XX</template>
									</td>
									<td v-if="isActual" :class="{ 'bg-white': isShow }">
										<v-text-field
											v-if="!isShow"
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
										<template v-else>XX</template>
									</td>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord
								:thStyle="{ fontSize: '0.9rem' }"
								:columnName="'加硫割り増し合計'"
								:tdStyle="{
									backgroundColor: 'white',
									borderBottom: '1px solid whitesmoke',
								}"
							>
								<template v-slot:td>
									<td class="bg-white border-bottom">XXX</td>
									<td class="bg-white border-bottom" v-if="isActual">XXX</td>
								</template>
							</ShowDetailRecord>
						</tbody>
					</table>
				</v-sheet>
				<v-sheet elevation="0" max-width="600px">
					<table
						width="100%"
						:class="`mt-4 show-dialog-table ${isShow || 'show-dialog-table--form'}`"
					>
						<tbody>
							<tr>
								<td class="title-in-cell">
									<h6 class="text-h6 font-weight-bold">軟質加硫</h6>
								</td>
								<template v-if="isActual">
									<th :style="width(200)">予算</th>
									<th :style="width(200)">実績</th>
								</template>
							</tr>
							<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'加硫日数'">
								<template v-slot:td>
									<td :class="{ 'bg-white': isShow || isActual }">
										<v-text-field
											v-if="!isShow && !isActual"
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
										<template v-else>XX</template>
									</td>
									<td v-if="isActual" :class="{ 'bg-white': isShow }">
										<v-text-field
											v-if="!isShow"
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
										<template v-else>XX</template>
									</td>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord
								:thStyle="{ fontSize: '0.9rem' }"
								:columnName="'通常勤務のマイナス'"
							>
								<template v-slot:td>
									<td :class="{ 'bg-white': isShow || isActual }">
										<v-text-field
											v-if="!isShow && !isActual"
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
										<template v-else>XX</template>
									</td>
									<td v-if="isActual" :class="{ 'bg-white': isShow }">
										<v-text-field
											v-if="!isShow"
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
										<template v-else>XX</template>
									</td>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'小計'">
								<template v-slot:td>
									<td :class="{ 'bg-white': isShow || isActual }">
										<v-text-field
											v-if="!isShow && !isActual"
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
										<template v-else>XX</template>
									</td>
									<td v-if="isActual" :class="{ 'bg-white': isShow }">
										<v-text-field
											v-if="!isShow"
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
										<template v-else>XX</template>
									</td>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'加硫回数'">
								<template v-slot:td>
									<td :class="{ 'bg-white': isShow || isActual }">
										<v-text-field
											v-if="!isShow && !isActual"
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
										<template v-else>XX</template>
									</td>
									<td v-if="isActual" :class="{ 'bg-white': isShow }">
										<v-text-field
											v-if="!isShow"
											v-model="todo"
											background-color="white"
											outlined
											dense
											hide-details
										/>
										<template v-else>XX</template>
									</td>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord
								:thStyle="{ fontSize: '0.9rem' }"
								:columnName="'加硫割り増し合計'"
								:tdStyle="{
									backgroundColor: 'white',
									borderBottom: '1px solid whitesmoke',
								}"
							>
								<template v-slot:td>
									<td class="bg-white border-bottom">XXX</td>
									<td class="bg-white border-bottom" v-if="isActual">XXX</td>
								</template>
							</ShowDetailRecord>
						</tbody>
					</table>
				</v-sheet>
			</v-sheet>
		</v-row>

		<v-sheet class="mt-4" elevation="0">
			<h6 class="text-h6 font-weight-bold">資材関係</h6>
			<v-sheet elevation="0" width="100%" max-width="600px">
				<table
					width="100%"
					:class="`mt-2 show-dialog-table ${isShow || 'show-dialog-table--form'}`"
				>
					<tbody>
						<ShowDetailRecord
							:thStyle="{ fontSize: '0.9rem' }"
							:columnName="'工場間接費割合'"
							:tdStyle="isShow ? { backgroundColor: 'white' } : {}"
						>
							<template v-slot:value>
								<!-- 初期値 0.21 -->
								<v-text-field
									v-if="!isShow"
									v-model="todo"
									background-color="white"
									outlined
									dense
									hide-details
								/>
								<template v-else>XX</template>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord
							:thStyle="{ fontSize: '0.9rem' }"
							:columnName="'販管費割合'"
							:tdStyle="isShow ? { backgroundColor: 'white' } : {}"
						>
							<template v-slot:value>
								<!-- 初期値 0.2 -->
								<v-text-field
									v-if="!isShow"
									v-model="todo"
									background-color="white"
									outlined
									dense
									hide-details
								/>
								<template v-else>XX</template>
							</template>
						</ShowDetailRecord>
					</tbody>
				</table>
			</v-sheet>
		</v-sheet>

		<template v-if="isActual">
			<v-sheet v-for="(item, i) in costItems" :key="i" class="mt-4" elevation="0">
				<h6 class="text-h6 font-weight-bold">{{ item.name }}</h6>
				<v-sheet elevation="0" width="100%">
					<table width="100%" class="mt-2 show-dialog-table">
						<tbody>
							<tr>
								<th
									:rowspan="column.onlyBudget ? 2 : 1"
									:colspan="column.onlyBudget ? 1 : 2"
									v-for="(column, j) in item.columns"
									:style="width(column.onlyBudget ? column.width : column.width * 2)"
									:key="j"
								>
									{{ column.name }}
								</th>
							</tr>
							<tr>
								<template
									v-for="(column, j) in item.columns.filter((column) => !column.onlyBudget)"
								>
									<th :style="width(column.width)" :key="`budget-${j}`">予算</th>
									<th :style="width(column.width)" :key="`actual-${j}`">実績</th>
								</template>
							</tr>
						</tbody>
						<tbody>
							<tr>
								<template v-for="(column, j) in item.columns">
									<td v-if="column.onlyBudget" :key="j">XXX</td>
									<template v-else>
										<td :key="`budget-${j}`">XXX</td>
										<td :key="`actual-${j}`">
											<v-text-field
												v-if="column.input && !isShow"
												v-model="todo"
												dense
												outlined
												hide-details
											/>
											<p v-else>0</p>
										</td>
									</template>
								</template>
							</tr>
						</tbody>
					</table>
					<v-btn v-if="!isShow" class="mt-2" color="secondary">
						<v-icon class="mr-1">mdi-plus</v-icon>
						{{ item.name }}を追加
					</v-btn>
				</v-sheet>
			</v-sheet>
		</template>

		<template v-else>
			<v-sheet v-for="(item, i) in costItems" :key="i" class="mt-4" elevation="0">
				<h6 class="text-h6 font-weight-bold">{{ item.name }}</h6>
				<v-sheet elevation="0" width="100%">
					<table width="100%" class="mt-2 show-dialog-table">
						<tbody>
							<tr>
								<th v-for="(column, j) in item.columns" :style="width(column.width)" :key="j">
									{{ column.name }}
								</th>
							</tr>
						</tbody>
						<tbody>
							<tr>
								<td v-for="(column, j) in item.columns" :key="j">
									<v-text-field
										v-if="column.input && !isShow"
										v-model="todo"
										dense
										outlined
										hide-details
									/>
									<p v-else>0</p>
								</td>
							</tr>
						</tbody>
					</table>
					<v-btn v-if="!isShow" class="mt-2" color="secondary">
						<v-icon class="mr-1">mdi-plus</v-icon>
						{{ item.name }}を追加
					</v-btn>
				</v-sheet>
			</v-sheet>
		</template>

		<v-row no-gutters class="mt-4">
			<v-col :lg="isActual ? 6 : 3" :sm="isActual ? 12 : 6" cols="12" class="px-1">
				<table width="100%" class="mt-2 show-dialog-table">
					<tbody>
						<tr v-if="isActual">
							<td class="title-in-cell" />
							<th>予算</th>
							<th>実績</th>
							<th>差額</th>
						</tr>

						<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'総合計'">
							<template v-slot:td>
								<td>XXX</td>
								<template v-if="isActual">
									<td>XXX</td>
									<td>XXX</td>
								</template>
							</template>
						</ShowDetailRecord>
					</tbody>
				</table>
			</v-col>
			<v-col :lg="isActual ? 6 : 3" :sm="isActual ? 12 : 6" cols="12" class="px-1">
				<table width="100%" class="mt-2 show-dialog-table">
					<tbody>
						<tr v-if="isActual">
							<td class="title-in-cell" />
							<th>予算</th>
							<th>実績</th>
							<th>差額</th>
						</tr>
						<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'総原価㎡単価'">
							<template v-slot:td>
								<td>XXX</td>
								<template v-if="isActual">
									<td>XXX</td>
									<td>XXX</td>
								</template>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'販売価格設定'">
							<template v-slot:td>
								<td>XXX</td>
								<template v-if="isActual">
									<td>XXX</td>
									<td>XXX</td>
								</template>
							</template>
						</ShowDetailRecord>
					</tbody>
				</table>
			</v-col>
			<v-col :lg="isActual ? 6 : 3" :sm="isActual ? 12 : 6" cols="12" class="px-1">
				<table width="100%" class="mt-2 show-dialog-table">
					<tbody>
						<tr v-if="isActual">
							<td class="title-in-cell" />
							<th>予算</th>
							<th>実績</th>
							<th>差額</th>
						</tr>
						<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'利益'">
							<template v-slot:td>
								<td>XXX</td>
								<template v-if="isActual">
									<td>XXX</td>
									<td>XXX</td>
								</template>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'利益率'">
							<template v-slot:td>
								<td>XXX</td>
								<template v-if="isActual">
									<td>XXX</td>
									<td>XXX</td>
								</template>
							</template>
						</ShowDetailRecord>
					</tbody>
				</table>
			</v-col>
			<v-col :lg="isActual ? 6 : 3" :sm="isActual ? 12 : 6" cols="12" class="px-1">
				<table width="100%" class="mt-2 show-dialog-table">
					<tbody>
						<tr v-if="isActual">
							<td class="title-in-cell" />
							<th>予算</th>
							<th>実績</th>
							<th>差額</th>
						</tr>
						<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'付加価値額'">
							<template v-slot:td>
								<td>XXX</td>
								<template v-if="isActual">
									<td>XXX</td>
									<td>XXX</td>
								</template>
							</template>
						</ShowDetailRecord>
						<ShowDetailRecord :thStyle="{ fontSize: '0.9rem' }" :columnName="'付加価値率'">
							<template v-slot:td>
								<td>XXX</td>
								<template v-if="isActual">
									<td>XXX</td>
									<td>XXX</td>
								</template>
							</template>
						</ShowDetailRecord>
					</tbody>
				</table>
			</v-col>
		</v-row>
	</v-sheet>
</template>

<script>
import rules from "../../../helper/rules"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"

export default {
	props: {
		isActual: {
			type: Boolean,
			default: false,
		},
		isShow: {
			type: Boolean,
			default: false,
		},
		costItems: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			todo: null,
			days: 100,
			hardVulcanizationDays: 6,
			softVulcanizationDays: 6,
			rules,
		}
	},
	methods: {
		width(width) {
			return { width: width + "px", minWidth: width + "px", maxWidth: width + "px" }
		},
		weekday(day) {
			const index = day % 7
			const weekdays = ["土", "日", "月", "火", "水", "木", "金"]
			return weekdays[index]
		},
		classByWeekday(day) {
			const index = day % 7
			if (index == 1) {
				return "sunday"
			} else if (index == 0) {
				return "saturday"
			} else {
				return ""
			}
		},
	},
	computed: {
		// 合計工数
		totalDays() {
			return (type, dayType) => {
				// type = employee or outsource
				// dayType = all or weekday or weekend
				// dayTypeをとtypeを使って、合計算出
				switch (dayType) {
					case "all":
						return 0
					case "weekday":
						return 0
					case "weekend":
						return 0
				}
			}
		},
		// 日毎の工数
		totalByDays() {
			return (day, type) => {
				return 0
			}
		},
	},
}
</script>

<style lang="scss" scoped>
th {
	font-weight: bold;
}
.saturday {
	background: #dbeafe;
}
.sunday {
	background: #fee2e2;
}

.show-dialog-table {
	th {
		&:not(:first-child) {
			border-left: 1px solid white;
		}
	}
	th.border-left {
		border-left: 1px solid white;
	}
	td.border-bottom {
		border-bottom: 1px solid whitesmoke;
	}
}

.days-table {
	width: 100%;
	max-width: 100%;
	thead {
		th {
			padding: 4px;
			background-color: whitesmoke;
			border: 1px solid white;
		}
		td {
			padding: 4px;
		}
	}
	tbody {
		th {
			padding: 4px;
			background-color: whitesmoke;
			border: 1px solid white;
		}
	}
	tr {
		position: relative;
	}
	.fixed {
		position: sticky;
		z-index: 1;
		&:before {
			content: "";
			position: absolute;
			top: 0;
			left: -1px;
			width: 100%;
			height: 100%;
			border-left: 1px solid white;
			border-bottom: 1px solid white;
		}
	}
}
.title-in-cell {
	border-left: transparent;
	border-top: transparent;
	background-color: white;
}
.no-border-bottom {
	border-bottom: transparent;
}
th {
	font-size: 0.9rem;
}
</style>